import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInstanceInfo as GetInstanceInfoQuery,
    InstanceInfo as InstanceInfoFragment,
} from 'nutshell-graphql-types';

import GET_INSTANCE_INFO from './graphql/queries/get-instance-info.graphql';

type OwnProps = {
    children: (arg1: ChildrenProps) => React.ReactElement;
};

type ChildrenProps = {
    sessionInstance: InstanceInfoFragment | null | undefined;
    errorMessage: string | null | undefined;
};

class InstanceInfoQuery extends Query<GetInstanceInfoQuery, Record<any, any>> {}

export const GetInstanceInfo = (props: OwnProps) => {
    return (
        <InstanceInfoQuery query={GET_INSTANCE_INFO}>
            {({data, error}) => {
                const sessionInstance = data ? data.sessionInstance : null;

                return props.children({
                    sessionInstance: sessionInstance,
                    // @ts-expect-error
                    errorMessage: safelyGetGraphQLErrorMessage(error),
                });
            }}
        </InstanceInfoQuery>
    );
};
